"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = exports.Cell = exports.Row = exports.BodyContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const util_1 = require("../../util");
const style_2 = require("../style");
exports.BodyContainer = styled_components_1.default.tbody `
`;
exports.Row = styled_components_1.default.tr `
`;
function toMaxWidth({ max }) {
    return R.isNil(max) ? 'auto' : `${max}px`;
}
exports.Cell = styled_components_1.default.th `
  ${style_1.default.Text.Definition.Paragraph};
  ${style_1.default.Text.Definition.Truncate};
  background: ${props => props.theme.Color.Layout.Lightest};
  padding: ${style_2.CELL_PADDING};
  text-align: ${(props) => (0, util_1.horizontalAlignmentToTextAlign)(props.alignment)};
  max-width: ${toMaxWidth};
  border-bottom: 1px solid ${props => props.theme.Color.Layout.Line};
`;
function Body({ table, }) {
    const { rows, prepareRow, getTableBodyProps } = table;
    return ((0, jsx_runtime_1.jsx)(exports.BodyContainer, Object.assign({}, getTableBodyProps(), { children: R.map((row) => {
            prepareRow(row);
            return ((0, jsx_runtime_1.jsx)(exports.Row, Object.assign({}, row.getRowProps(), { children: R.map((cell) => {
                    return ((0, jsx_runtime_1.jsx)(exports.Cell, Object.assign({}, cell.getCellProps(), { alignment: R.path(['column', 'schema', 'alignment'], cell), max: R.path(['column', 'schema', 'max'], cell) }, { children: cell.render('Cell') })));
                }, row.cells) })));
        }, rows) })));
}
exports.Body = Body;
